import React from 'react'
import { Form, Modal } from 'react-bootstrap'
import Button from '@components/common/Button/Button.component'
import './CallConfirmation.css'

type CallConfirmationProps = {
  show: boolean
  onHide: () => void
  confirm: () => void
  name: string
}

const CallConfirmation: React.FC<CallConfirmationProps> = ({
  show,
  onHide,
  confirm,
  name,
}) => {
  return (
    <Modal show={show} onHide={onHide} centered className="call-modal">
      <Modal.Header closeButton>
        <Modal.Title>Call patient?</Modal.Title>
      </Modal.Header>
      <Modal.Body className="call-modal-body">
        Are you sure you want to proceed with the patient call?
        <br />
        {name}
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-between">
        <Form.Check
          type="checkbox"
          label="Don't show again"
          //   checked={dontShowAgain}
          //   onChange={handleCheckboxChange}
        />
        <div>
          <Button size="md" className="button-tertiary" onClick={onHide}>
            Cancel
          </Button>
          <Button size="md" className="button-primary" onClick={confirm}>
            Confirm
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  )
}

export default CallConfirmation
